export const iqTestQuestions = [
  // QUESTION 1 - Verbal Comprehension (Easy)
  {
    id: 1,
    question: "Choose the word most similar to 'Begin':",
    type: "verbal-comprehension",
    options: ["End", "Start", "Stop", "Finish"],
    correctAnswer: 1, // Start
    hasImage: false
  },
  
  // QUESTION 2 - Fluid Reasoning (Easy)
  {
    id: 2,
    question: "Tom is older than Sarah. Sarah is older than Mike. Who is youngest?",
    type: "fluid-reasoning",
    options: ["Tom", "Sarah", "Mike", "Cannot determine"],
    correctAnswer: 2, // Mike
    hasImage: false
  },

  // QUESTION 3 - Quantitative Reasoning (Easy)
  {
    id: 3,
    question: "What is 15% of 60?",
    type: "quantitative-reasoning",
    options: ["6", "9", "12", "15"],
    correctAnswer: 1, // 9
    hasImage: false
  },

  // QUESTION 4 - Working Memory (Easy)
  {
    id: 4,
    question: "Look at this sequence: 5, 2, 8. If you multiply each number by 2, what is the result?",
    type: "working-memory",
    options: ["7, 4, 10", "10, 4, 16", "15, 12, 18", "3, 0, 6"],
    correctAnswer: 1, // 10, 4, 16
    hasImage: false
  },

  // QUESTION 5 - Verbal Comprehension (Easy)
  {
    id: 5,
    question: "Which word does not belong with the others?",
    type: "verbal-comprehension",
    options: ["Apple", "Orange", "Banana", "Carrot"],
    correctAnswer: 3, // Carrot
    hasImage: false
  },

// QUESTION 6 - Quantitative Reasoning (Medium)
  {
    id: 6,
    question: "If a book has 240 pages and you read 15 pages per day, how many days will it take to finish the book?",
    type: "quantitative-reasoning",
    options: ["14 days", "16 days", "18 days", "20 days"],
    correctAnswer: 1, // 16 days
    hasImage: false
  },

  // QUESTION 7 - Fluid Reasoning (Medium)
  {
    id: 7,
    question: "What comes next in the series: 2, 6, 18, 54, ?",
    type: "fluid-reasoning",
    options: ["108", "162", "216", "270"],
    correctAnswer: 1, // 162 (multiply by 3 each time)
    hasImage: false
  },

  // QUESTION 8 - Verbal Comprehension (Easy)
  {
    id: 8,
    question: "Choose the word most similar to 'Brief':",
    type: "verbal-comprehension",
    options: ["Long", "Short", "Detailed", "Complex"],
    correctAnswer: 1, // Short
    hasImage: false
  },

  // QUESTION 9 - Working Memory (Easy)
  {
    id: 9,
    question: "If you count backwards from 10 to 6, how many numbers do you say?",
    type: "working-memory",
    options: ["4", "5", "6", "7"],
    correctAnswer: 1, // 5 (10, 9, 8, 7, 6)
    hasImage: false
  },

  // QUESTION 10 - Visual-Spatial (Easy)
  {
    id: 10,
    question: "What shape comes fourth?",
    type: "visual-spatial",
    options: ["A", "B", "C", "D"],
    correctAnswer: 1, // B 
    hasImage: true,
    imagePath: "/images/visual-spacial-q1o.webp"
  },

  // QUESTION 11 - Quantitative Reasoning (Medium)
  {
    id: 11,
    question: "If a car travels 180 miles in 3 hours, what is its average speed?",
    type: "quantitative-reasoning",
    options: ["45 mph", "50 mph", "55 mph", "60 mph"],
    correctAnswer: 3, // 50 mph
    hasImage: false
  },

  // QUESTION 12 - Fluid Reasoning (Easy)
  {
    id: 12,
    question: "What comes next in the series: 7, 14, 21, 28, ?",
    type: "fluid-reasoning",
    options: ["30", "33", "34", "35"],
    correctAnswer: 3, // 35
    hasImage: false
  },

  // QUESTION 13 - Visual-Spatial (Easy)
  {
    id: 13,
    question: "Which of the following boxes completes the pattern?",
    type: "visual-spatial",
    options: ["A", "B", "C", "D", "E"],
    correctAnswer: 2, // C
    hasImage: true,
    imagePath: "/images/visual-spacial-q2o.webp" 
  },

  // QUESTION 14 - Verbal Comprehension (Medium)
  {
    id: 14,
    question: "Choose the word most opposite to 'Ancient':",
    type: "verbal-comprehension",
    options: ["Old", "Historic", "Modern", "Traditional"],
    correctAnswer: 2, // Modern
    hasImage: false
  },

  // QUESTION 15 - Fluid Reasoning (Medium)
  {
    id: 15,
    question: "If all Zips are Zaps and no Zaps are Zops, then:",
    type: "fluid-reasoning",
    options: ["Some Zips are Zops", "All Zips are Zops", "No Zips are Zops", "Some Zops are Zips"],
    correctAnswer: 2, // No Zips are Zops
    hasImage: false
  },

  // QUESTION 16 - Working Memory (Medium) - REPLACED
  {
    id: 16,
    question: "Look at these items: BOOK, RED, 12, CHAIR. Which word has the fewest letters?",
    type: "working-memory",
    options: ["BOOK", "RED", "12", "CHAIR"],
    correctAnswer: 1, // RED
    hasImage: false
  },

  // QUESTION 17 - Quantitative Reasoning (Easy)
  {
    id: 17,
    question: "If you save $5 every week, how much will you have saved after 8 weeks?",
    type: "quantitative-reasoning",
    options: ["$35", "$40", "$45", "$50"],
    correctAnswer: 1, // $40
    hasImage: false
  },

  // QUESTION 18 - Verbal Comprehension (Medium)
  {
    id: 18,
    question: "How are a telescope and a microscope similar?",
    type: "verbal-comprehension",
    options: ["They both make things appear larger or clearer", "They're both made of wood", "They both use electricity", "They're both very small"],
    correctAnswer: 0, // They both make things appear larger or clearer
    hasImage: false
  },

  // QUESTION 19 - Visual-Spatial (Medium)
  {
    id: 19,
    question: "Select the figure that is a direct rotation of the figure on the left",
    type: "visual-spatial",
    options: ["A", "B", "C", "D", "E"],
    correctAnswer: 3, 
    hasImage: true,
    imagePath: "/images/visual-spacial-q3o.webp"
  },

  // QUESTION 20 - Fluid Reasoning (Medium)
  {
    id: 20,
    question: "If Monday is day 1, what day is day 5?",
    type: "fluid-reasoning",
    options: ["Thursday", "Friday", "Saturday", "Sunday"],
    correctAnswer: 1, // Friday
    hasImage: false
  },

  // QUESTION 21 - Visual-Spatial (Hard)
  {
    id: 21,
    question: "From the top view shown, which 3D structure is the match?",
    type: "visual-spatial",
    options: ["A", "B", "C", "D", "E"],
    correctAnswer: 4, // E (None)
    hasImage: true,
    imagePath: "/images/visual-spacial-q4o.webp"
  },
  // QUESTION 22 - Working Memory (Medium)
  {
    id: 22,
    question: "Start with 12, add 8, divide by 4, multiply by 3. What is the result?",
    type: "working-memory",
    options: ["12", "15", "18", "21"],
    correctAnswer: 1, // 15
    hasImage: false
  },

  // QUESTION 23 - Quantitative Reasoning (Medium)
  {
    id: 23,
    question: "The price of an item increases from $40 to $50. What is the percentage increase?",
    type: "quantitative-reasoning",
    options: ["20%", "25%", "30%", "35%"],
    correctAnswer: 1, // 25%
    hasImage: false
  },

  // QUESTION 24 - Verbal Comprehension (Medium)
  {
    id: 24,
    question: "If all birds can fly and penguins are birds, but penguins cannot fly, what does this tell us?",
    type: "verbal-comprehension",
    options: ["Penguins are not birds", "The first statement is incorrect", "All birds except penguins can fly", "Flying is not essential to being a bird"],
    correctAnswer: 1, // The first statement is incorrect
    hasImage: false
  },

  // QUESTION 25 - Fluid Reasoning (Easy)
  {
    id: 25,
    question: "All flowers need water. Roses are flowers. Therefore:",
    type: "fluid-reasoning",
    options: ["All roses are red", "Roses need water", "Water makes flowers grow", "Some flowers don't need water"],
    correctAnswer: 1, // Roses need water
    hasImage: false
  },

  // QUESTION 26 - Visual-Spatial (Medium)
  {
    id: 26,
    question: "Which of these options is a rotation of the question figure?",
    type: "visual-spatial",
    options: ["A", "B", "C", "D"],
    correctAnswer: 0, // A
    hasImage: true,
    imagePath: "/images/visual-spacial-q5o.webp" 
  },

  // QUESTION 27 - Working Memory (Medium) - REPLACED
  {
    id: 27,
    question: "Count the number of vowels (A, E, I, O, U) in the word 'EDUCATION':",
    type: "working-memory",
    options: ["3", "4", "5", "6"],
    correctAnswer: 2, // 5 (E-U-A-I-O)
    hasImage: false
  },

  // QUESTION 28 - Quantitative Reasoning (Medium)
  {
    id: 28,
    question: "A store sells 9 apples for $6. How much do 27 apples cost?",
    type: "quantitative-reasoning",
    options: ["$16", "$17", "$18", "$19"],
    correctAnswer: 2, // $18
    hasImage: false
  },

  // QUESTION 29 - Fluid Reasoning (Medium)
  {
    id: 29,
    question: "What comes next: A1, C3, E5, G7, ?",
    type: "fluid-reasoning",
    options: ["H8", "I9", "J10", "K11"],
    correctAnswer: 1, // I9 (letters increase by 2, numbers by 2)
    hasImage: false
  },

// QUESTION 30 - Working Memory (Medium)
  {
    id: 30,
    question: "Look at these numbers: 8, 3, 7, 2, 9, 1, 6. If you arrange them from smallest to largest, what number is in the 5th position?",
    type: "working-memory",
    options: ["6", "7", "8", "9"],
    correctAnswer: 1, // 7 (sorted: 1,2,3,6,7,8,9 - 5th position is 7)
    hasImage: false
  },

  // QUESTION 31 - Verbal Comprehension (Medium)
  {
    id: 31,
    question: "Choose the word most similar to 'Innovative':",
    type: "verbal-comprehension",
    options: ["Traditional", "Creative", "Boring", "Old-fashioned"],
    correctAnswer: 1, // Creative
    hasImage: false
  },

  // QUESTION 32 - Quantitative Reasoning (Medium)
  {
    id: 32,
    question: "If x + 8 = 15, what is the value of 2x?",
    type: "quantitative-reasoning",
    options: ["12", "14", "16", "18"],
    correctAnswer: 1, // 14
    hasImage: false
  },

  // QUESTION 33 - Verbal Comprehension (Easy)
  {
    id: 33,
    question: "Choose the word most similar to 'Transparent':",
    type: "verbal-comprehension",
    options: ["Solid", "Clear", "Dark", "Heavy"],
    correctAnswer: 1, // Clear
    hasImage: false
  },

  // QUESTION 34 - Working Memory (Medium) - REPLACED
  {
    id: 34,
    question: "Look at these words: FAST, SLOW, BIG, SMALL. How many describe speed?",
    type: "working-memory",
    options: ["1", "2", "3", "4"],
    correctAnswer: 1, // 2 (FAST and SLOW)
    hasImage: false
  },

  // QUESTION 35 - Visual-Spatial (Medium)
  {
    id: 35,
    question: "Which symbol is missing from the middle cube?",
    type: "visual-spatial",
    options: ["A", "B", "C", "D", "E"],
    correctAnswer: 3, // D
    hasImage: true,
    imagePath: "/images/visual-spacial-q6o.webp"
  },

// QUESTION 36 - Working Memory (Medium)
  {
    id: 36,
    question: "Look at this word: ELEPHANT. How many letters appear exactly once in this word?",
    type: "working-memory",
    options: ["4", "5", "6", "7"],
    correctAnswer: 2, // 6 (L-P-H-A-N-T appear once, E appears twice)
    hasImage: false
  },

  // QUESTION 37 - Fluid Reasoning (Medium)
  {
    id: 37,
    question: "Complete the analogy: Engine is to Car as:",
    type: "fluid-reasoning",
    options: ["Wheel is to Bicycle", "Heart is to Body", "Window is to House", "Page is to Book"],
    correctAnswer: 1, // Heart is to Body
    hasImage: false
  },

  // QUESTION 38 - Quantitative Reasoning (Medium)
  {
    id: 38,
    question: "What is one-third of 99?",
    type: "quantitative-reasoning",
    options: ["27", "30", "33", "36"],
    correctAnswer: 2, // 33
    hasImage: false
  },

  // QUESTION 39 - Quantitative Reasoning (Medium)
  {
    id: 39,
    question: "A train travels 240 km in 3 hours. If it maintains the same speed, how far will it travel in 5 hours?",
    type: "quantitative-reasoning",
    options: ["350 km", "400 km", "420 km", "450 km"],
    correctAnswer: 1, // 400 km
    hasImage: false
  },

  // QUESTION 40 - Working Memory (Hard)
  {
    id: 40,
    question: "Starting with the number 100, subtract 7 repeatedly. What is the 8th number in this sequence?",
    type: "working-memory",
    options: ["44", "51", "58", "65"],
    correctAnswer: 1, // 51 (100, 93, 86, 79, 72, 65, 58, 51)
    hasImage: false
  },

  // QUESTION 41 - Quantitative Reasoning (Easy)
  {
    id: 41,
    question: "What is half of a quarter of 200?",
    type: "quantitative-reasoning",
    options: ["20", "25", "30", "35"],
    correctAnswer: 1, // 25
    hasImage: false
  },

  // QUESTION 42 - Fluid Reasoning (Hard)
  {
    id: 42,
    question: "What comes next in the series: 1, 4, 9, 16, 25, ?",
    type: "fluid-reasoning",
    options: ["30", "32", "36", "49"],
    correctAnswer: 2, // 36 (perfect squares: 1², 2², 3², 4², 5², 6²)
    hasImage: false
  },

  // QUESTION 43 - Quantitative Reasoning (Hard)
  {
    id: 43,
    question: "A rectangular garden is twice as long as it is wide. If its width is 6 meters, what is its area?",
    type: "quantitative-reasoning",
    options: ["36 square meters", "48 square meters", "72 square meters", "144 square meters"],
    correctAnswer: 2, // 72 square meters
    hasImage: false
  },

  // QUESTION 44 - Working Memory (Hard)
  {
    id: 44,
    question: "Start with 24, divide by 3, add 12, multiply by 2, subtract 5. What is the final result?",
    type: "working-memory",
    options: ["35", "37", "39", "41"],
    correctAnswer: 0, // 35
    hasImage: false
  },

  // QUESTION 45 - Verbal Comprehension (Hard)
  {
    id: 45,
    question: "How are 'catalyst' and 'inhibitor' related?",
    type: "verbal-comprehension",
    options: ["They perform opposite functions", "They mean the same thing", "They're both types of metals", "They're unrelated scientific terms"],
    correctAnswer: 0, // They perform opposite functions
    hasImage: false
  },

 // QUESTION 46 - Fluid Reasoning (Hard)
  {
    id: 46,
    question: "If the day before yesterday was Friday, what day will it be in 2 days?",
    type: "fluid-reasoning",
    options: ["Saturday", "Sunday", "Monday", "Tuesday"],
    correctAnswer: 3, // Tuesday (Friday->Saturday->Sunday->Monday->Tuesday)
    hasImage: false
  },

// QUESTION 47 - Quantitative Reasoning (Hard)
  {
    id: 47,
    question: "If 5 workers can complete a job in 12 days, how many days will it take 8 workers to complete the same job?",
    type: "quantitative-reasoning",
    options: ["7.5 days", "8 days", "9 days", "10 days"],
    correctAnswer: 0, // 7.5 days
    hasImage: false
  },

  // QUESTION 48 - Verbal Comprehension (Hard)
  {
    id: 48,
    question: "Choose the word most similar to 'Pragmatic':",
    type: "verbal-comprehension",
    options: ["Idealistic", "Practical", "Emotional", "Theoretical"],
    correctAnswer: 1, // Practical
    hasImage: false
  },

  // QUESTION 49 - Fluid Reasoning (Hard)
  {
    id: 49,
    question: "In a logical sequence, if RED = 3, BLUE = 4, GREEN = 5, what does YELLOW equal?",
    type: "fluid-reasoning",
    options: ["5", "6", "7", "8"],
    correctAnswer: 1, // 6 (number of letters)
    hasImage: false
  },

  // QUESTION 50 - Verbal Comprehension (Hard)
  {
    id: 50,
    question: "What does it mean if something is 'tangible'?",
    type: "verbal-comprehension",
    options: ["It can be touched or felt", "It's very expensive", "It's invisible", "It's theoretical"],
    correctAnswer: 0, // It can be touched or felt
    hasImage: false
  }
];

// Helper function to get question by ID
export const getQuestionById = (id) => {
  return iqTestQuestions.find(q => q.id === id);
};

// Helper function to get all questions with images
export const getQuestionsWithImages = () => {
  return iqTestQuestions.filter(q => q.hasImage);
};

// Helper function to get questions by type
export const getQuestionsByType = (type) => {
  return iqTestQuestions.filter(q => q.type === type);
};